var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "damage-validation-mobilier view" }, [
    _vm.isE2EFlow
      ? _c(
          "div",
          { staticClass: "view_top" },
          [
            _c("ma-navbar-stepper", {
              attrs: { numberOfStep: 3, textOfStep: _vm.$t("stepper.step3") },
            }),
          ],
          1
        )
      : _vm._e(),
    _c("div", { staticClass: "view_content" }, [
      _c("div", { staticClass: "view_content_markdown" }, [
        _c("h1", { staticClass: "damage-validation_title" }, [
          _vm._v(_vm._s(_vm.$t("damageValidation.mobilier.title"))),
        ]),
        _c("div", { staticClass: "view_content_image" }, [
          _c("img", {
            staticClass: "mg mg--t-4 mg--b-4",
            attrs: { src: require("@/assets/images/self-care/Picto.png") },
          }),
          _c("h3", { staticClass: "solution-title" }, [
            _vm._v(_vm._s(_vm.$t("damageValidation.mobilier.solution"))),
          ]),
          _c("p", { staticClass: "solution-text" }, [
            _vm._v(_vm._s(_vm.$t("damageValidation.mobilier.text1"))),
          ]),
          _c("p", { staticClass: "mg mg--b-4" }, [
            _vm._v(_vm._s(_vm.$t("damageValidation.mobilier.text2"))),
          ]),
        ]),
        _c("div", { staticClass: "view_content_compensation" }, [
          _c(
            "div",
            { staticClass: "damage-validation_compensation" },
            [
              _c("div", { staticClass: "accordeon-container" }, [
                _c(
                  "p",
                  { staticClass: "mg mg--b-4 blueLight headline-large" },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.replaceDots(
                          _vm.mobilierDamagesAmmounts.compensation_base
                        )
                      ) + " €"
                    ),
                  ]
                ),
              ]),
              _c(
                "ma-accordion",
                { ref: "accordion" },
                [
                  _c("template", { slot: "accordionTop" }, [
                    _c("p", { staticClass: "accordion_title" }, [
                      _vm._v(
                        _vm._s(_vm.$t("damageValidation.accordion.title"))
                      ),
                    ]),
                  ]),
                  _c(
                    "template",
                    { slot: "accordionBottom" },
                    [
                      _vm._l(_vm.mobilierDamages, function (damage, index) {
                        return _c(
                          "ul",
                          { key: index, staticClass: "mg mg--t-2" },
                          [
                            damage.brand !== undefined
                              ? _c("li", { staticClass: "mg mg--b-4" }, [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "text-medium gray bold mg mg--b-2",
                                    },
                                    [_vm._v(_vm._s(damage.product))]
                                  ),
                                  _c("p", { staticClass: "text-small gray" }, [
                                    _vm._v(
                                      _vm._s(damage.brand) +
                                        " " +
                                        _vm._s(damage.reference)
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "damage-validation-mobilier_details",
                                    },
                                    [
                                      _c(
                                        "p",
                                        { staticClass: "text-small gray" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "damageValidation.accordion.age"
                                                )
                                              )
                                          ),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.mobilierDamagesAmmounts
                                                  .damages[index].age
                                              )
                                            ),
                                          ]),
                                        ]
                                      ),
                                      _c(
                                        "p",
                                        { staticClass: "text-small gray" },
                                        [
                                          _vm._v(" Valeur à neuf:"),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.replaceDots(
                                                  _vm.mobilierDamagesAmmounts
                                                    .damages[index].new_value
                                                )
                                              ) + "€"
                                            ),
                                          ]),
                                        ]
                                      ),
                                      _vm.mobilierDamagesAmmounts.damages[index]
                                        .deprecation !== 0 && _vm.isOptionRAN
                                        ? _c(
                                            "p",
                                            {
                                              staticClass:
                                                "text-small gray line-through",
                                            },
                                            [
                                              _vm._v(" Vétusté:"),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.mobilierDamagesAmmounts
                                                      .damages[index]
                                                      .deprecation
                                                  ) + "€"
                                                ),
                                              ]),
                                            ]
                                          )
                                        : _c(
                                            "p",
                                            {
                                              staticClass:
                                                "text-small gray line",
                                            },
                                            [
                                              _vm._v(" Vétusté:"),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.mobilierDamagesAmmounts
                                                      .damages[index]
                                                      .deprecation
                                                  ) + "€"
                                                ),
                                              ]),
                                            ]
                                          ),
                                    ]
                                  ),
                                ])
                              : _c("li", { staticClass: "mg mg--b-4" }, [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "text-medium gray bold mg mg--b-2",
                                    },
                                    [_vm._v(_vm._s(damage.product))]
                                  ),
                                  _c("p", { staticClass: "text-small gray" }, [
                                    _vm._v(_vm._s(damage.category)),
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "damage-validation-mobilier_details",
                                    },
                                    [
                                      _c(
                                        "p",
                                        { staticClass: "text-small gray" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "damageValidation.accordion.age"
                                                )
                                              )
                                          ),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.mobilierDamagesAmmounts
                                                  .damages[index].age
                                              )
                                            ),
                                          ]),
                                        ]
                                      ),
                                      _c(
                                        "p",
                                        { staticClass: "text-small gray" },
                                        [
                                          _vm._v(" Valeur à neuf:"),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.replaceDots(
                                                  _vm.mobilierDamagesAmmounts
                                                    .damages[index].new_value
                                                )
                                              ) + "€"
                                            ),
                                          ]),
                                        ]
                                      ),
                                      _vm.mobilierDamagesAmmounts.damages[index]
                                        .deprecation !== 0 && _vm.isOptionRAN
                                        ? _c(
                                            "p",
                                            {
                                              staticClass:
                                                "text-small gray line-through",
                                            },
                                            [
                                              _vm._v(" Vétusté:"),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.mobilierDamagesAmmounts
                                                      .damages[index]
                                                      .deprecation
                                                  ) + "€"
                                                ),
                                              ]),
                                            ]
                                          )
                                        : _c(
                                            "p",
                                            {
                                              staticClass:
                                                "text-small gray line",
                                            },
                                            [
                                              _vm._v(" Vétusté:"),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.mobilierDamagesAmmounts
                                                      .damages[index]
                                                      .deprecation
                                                  ) + "€"
                                                ),
                                              ]),
                                            ]
                                          ),
                                    ]
                                  ),
                                ]),
                          ]
                        )
                      }),
                      _vm.hasDepreciation() && _vm.isOptionRAN
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "damage-validation-mobilier_details mg mg--t-4",
                            },
                            [
                              _c(
                                "p",
                                { staticClass: "text-medium gray mg mg--t-1" },
                                [
                                  _vm._v(
                                    "Vétusté non appliquée car vous bénéficiez de l’option Remise à neuf"
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        {
                          staticClass:
                            "damage-validation-mobilier_details mg mg--t-4",
                        },
                        [
                          _c(
                            "p",
                            { staticClass: "text-medium gray mg mg--t-1" },
                            [
                              _vm._v("Base d’indemnisation"),
                              _c(
                                "span",
                                { staticClass: "text-medium gray mg mg--t-1" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.replaceDots(
                                        _vm.mobilierDamagesAmmounts
                                          .compensation_base
                                      )
                                    ) + "€*"
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "content-material mg mg--t-4" },
                        [
                          _c(
                            "p",
                            {
                              staticClass: "text-small",
                              on: { click: _vm.handleOpenDescriptionModal },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "blueDark mg mg--r-1" },
                                [
                                  _vm._v(
                                    "Comment est calculée cette indemnisation?"
                                  ),
                                ]
                              ),
                              _c("svgicon", {
                                attrs: {
                                  name: "question",
                                  color: "#005BA5",
                                  width: "12",
                                  height: "12",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "ma-modal",
                            {
                              ref: "modalDescription",
                              staticClass:
                                "modal-confirmation damage-validation-mobilier__modal",
                              attrs: { type: "smallCenter" },
                              on: {
                                "modal:close": _vm.handleCloseDescriptionModal,
                              },
                            },
                            [
                              _c("template", { slot: "modalContent" }, [
                                _c("div", { staticClass: "modal__main view" }, [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "headline-medium center gray mg mg--b-5",
                                    },
                                    [
                                      _vm._v(
                                        "Comment cette indemnisation est calculée"
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "p",
                                    {
                                      staticClass: "text-small gray mg mg--b-5",
                                    },
                                    [
                                      _vm._v(
                                        "L'indemnisation que vous recevrez pour vos dommages mobiliers dépend de :"
                                      ),
                                    ]
                                  ),
                                  _c("ul", [
                                    _c(
                                      "li",
                                      {
                                        staticClass:
                                          "bullet text-small gray mg mg--b-2",
                                      },
                                      [
                                        _vm._v(
                                          "La valeur de votre bien sur le marché actuellement. Si votre bien n'est plus en vente, cette valeur est basée sur un produit équivalent.Une validation de l’estimation de la valeur du bien peut être faite par l’un de nos conseillers."
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "li",
                                      {
                                        staticClass:
                                          "bullet text-small gray mg mg--b-2",
                                      },
                                      [
                                        _vm._v(
                                          "Le montant de la vétusté est calculé en multipliant la valeur actualisée de votre bien par son âge et un pourcentage qui dépend de sa catégorie. Par exemple, un ordinateur vieux de 2 ans et dont la valeur à neuf est de 1000 euros se verra appliquer une vétusté de 240 € (1000€ x 2 x 12% = 240€)."
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "li",
                                      {
                                        staticClass:
                                          "bullet text-small gray mg mg--b-2",
                                      },
                                      [
                                        _vm._v(
                                          "Si vous avez pris l'option « remplacement à neuf », la vétusté ne sera pas déduite pour calculer la base d'indemnisation. Si vous n'avez pas pris l'option, la vétusté sera déduite de votre indemnisation."
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "li",
                                      {
                                        staticClass:
                                          "bullet text-small gray mg mg--b-4",
                                      },
                                      [
                                        _vm._v(
                                          "La franchise de votre contrat sera déduite de l'indemnisation de l'ensemble de vos dommages."
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn mainBlue damage-validation_button",
                                      on: {
                                        click: _vm.handleCloseDescriptionModal,
                                      },
                                    },
                                    [
                                      _c("p", { staticClass: "text-medium" }, [
                                        _vm._v("Accepter"),
                                      ]),
                                    ]
                                  ),
                                ]),
                              ]),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ],
                2
              ),
            ],
            1
          ),
        ]),
        _c("p", { staticClass: "mg mg--t-4" }, [
          _vm._v(_vm._s(_vm.$t("damageValidation.mobilier.text3"))),
        ]),
        _c("p", { staticClass: "mg mg--t-4" }, [
          _vm._v(_vm._s(_vm.$t("damageValidation.mobilier.text4"))),
        ]),
        _c("p", { staticClass: "mg mg--t-4" }, [
          _vm._v(_vm._s(_vm.$t("damageValidation.mobilier.text5"))),
        ]),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "view_actions" },
      [
        _c("ma-buttons-next-actions", {
          staticClass: "buttonsNextActions",
          attrs: {
            handleButtonClick: _vm.handlePrimaryButtonClick,
            handleButtonClickWhiteBtn: _vm.handleSecondaryButtonClick,
            title: _vm.$t("damageValidation.mobilier.actions.primary"),
            titleWhiteBtn: _vm.$t(
              "damageValidation.mobilier.actions.secondary"
            ),
            btnType: "functionalBtnWhite",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }